import { IUserActionsHistoryStored } from "../../models/user-actions-history.models";

const RANDOM_ID_RADIX = 36;
const RANDOM_ID_SLICE_START = 2;
const RANDOM_ID_SLICE_END = 9;

export const emptyStore = (): IUserActionsHistoryStored => ({
  v: 1,
  items: [],
});

export const newEntryId = (): string =>
  `${Date.now()}_${Math.random()
    .toString(RANDOM_ID_RADIX)
    .slice(RANDOM_ID_SLICE_START, RANDOM_ID_SLICE_END)}`;
